import React, { useEffect, useState } from 'react';
import { get, has, isEmpty } from 'lodash';
import Card from 'kepler/lib/components/Card';
import PropTypes from 'prop-types';
import Favorite from './Favorite';
import MyAppCardItemIcon from './MyAppCardItemIcon';
import MyAppCardItemButton from './MyAppCardItemButton';
import MyAppCardItemOffer from './MyAppCardItemOffer';
import getContent from '../lib/dictionaryFetcher';
import { EXTERNAL_PARTNERS } from '../lib/constants';

const MyAppCardItem = props => {
  const {
    app,
    item,
    showOffer,
    toggleFavorite,
    user,
    btnType,
    btnText,
    callback
  } = props;

  const isExternal = get(item, 'external', false),
    title = get(item, 'name', ''),
    description = get(item, 'description', ''),
    subtitle = getContent('merchanthub', `apps.${app}.subtitle`),
    defaultBtnText = getContent('merchanthub', `apps.${app}.button`, ''),
    isTool = !isEmpty(item) && item.type === 'tool',
    appLabel = getContent('merchanthub', `apps.${app}.new`),
    hasFavorite = isTool && item.active && !isExternal && has(item, 'favorite');

  const titleId = `${title.split(' ').join('')}-title`;

  const [hoverClass, updateHoverClass] = useState('');

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const elem = document.getElementsByClassName(titleId)[0];
      if (
        get(elem, 'scrollHeight', 0) !== get(elem, 'offsetHeight', 0) ||
        get(elem, 'scrollWidth', 0) !== get(elem, 'offsetWidth', 0)
      ) {
        updateHoverClass('hover-title');
      }
    }
  }, []);

  const renderButton = () => {
    return (
      <MyAppCardItemButton
        id={`btn-${app}`}
        btnType={btnType}
        btnText={isExternal ? defaultBtnText : btnText || defaultBtnText}
        onClick={() => callback(app)}
      />
    );
  };

  const renderOffer = () => {
    return <MyAppCardItemOffer app={app}>{renderButton()}</MyAppCardItemOffer>;
  };

  return (
    <Card
      className={`myapps-card ${app}-card${
        isTool && !isExternal ? ' tools-card' : ''
      }`}
    >
      <div className="myapps-card-header">
        <MyAppCardItemIcon app={app} user={user} hasFavorite={hasFavorite} />
        {hasFavorite && (
          <Favorite tool={item} toggleFavorite={toggleFavorite} />
        )}
        <h4 className={`${titleId} ${hoverClass}`}>{title}</h4>
      </div>
      {EXTERNAL_PARTNERS.includes(get(item, 'key')) && (
        <div className="myapps-card-new">{appLabel}</div>
      )}
      <div className="myapps-card-content">
        {subtitle && <h5>{subtitle}</h5>}
        <p>{description} </p>
      </div>
      {showOffer ? renderOffer() : renderButton()}
    </Card>
  );
};

MyAppCardItem.propTypes = {
  app: PropTypes.string,
  user: PropTypes.object,
  item: PropTypes.object,
  btnType: PropTypes.string,
  btnText: PropTypes.string,
  toggleFavorite: PropTypes.func,
  callback: PropTypes.func,
  showOffer: PropTypes.bool
};

export default MyAppCardItem;
